<template lang='pug'>
.page-wrapper
    Navbar
    .content-wrapper
        Loader(v-if='isLoading')
        .content
            h1
                span Cookie Policy
            span “Cookies are small text files that are placed on your computer by websites that you visit. They are widely used in order to make websites work, or work more efficiently, as well as to provide information to the owners of the site.” - Information Commissioner’s Office

            span We use the following types of cookie:
            ul
                li Strictly necessary cookies These cookies are essential for Reward Deals to work e.g. cookies that allow you to login to your account.
                li Functionality cookies These are cookies that help improve your experience on Reward Deals e.g. to remember personal preferences or to display your dashboard information
                li Analytical / performance cookies These cookies help us understand how people use Reward Deals so that we can, for example, improve the website or add new features.
                li Targeting cookies These cookies are used so that we can advertise Reward Deals and it's services on other platforms (e.g. Facebook)
                li Third party cookies These cookies are used to provide integrations with other services - e.g. to login with Facebook or to show an embedded youtube video.
            div Below is a more detailed list of some of the cookies we use and the reasons why:
            ul 
                li Session (ldSession) This cookie is used so we can know where your current session on Reward Deals began (e.g. that you came from our Facebook page, or were recommended by another member). This lets us award points for people recommending friends and work out which of our channels (e.g. social media, our app, etc) are most popular.
                li Last Seen (postLastSeen) This tells us when you last visited the Reward Deals homepage. We use this information to show you how many new posts there have been since your last visit.
                li Authentication (token, user, sessionId) We use these cookies to handle user login, for security and to prevent abuse or breach of our Community Guidelines
                li Google Analytics (_ga, _gid, _gat*) These cookies are used to collect information about how visitors use our website. The cookies collect information in a way that does not directly identify anyone, including the number of visitors to the website, where visitors have come to the website from and the pages they visited. Read Google’s overview of privacy and safeguarding data.
                li Youtube (various cookies from youtube.com) We embed videos from YouTube using YouTube’s privacy-enhanced mode. This mode may set cookies on your computer once you click on the YouTube video player, but YouTube will not store personally-identifiable cookie information for playbacks of embedded videos using the privacy-enhanced mode. Read YouTube’s embedding videos information page.
                li Facebook (various cookies from facebook.com) We use Facebook as an optional way to join/login to Reward Deals, as well as providing share and like buttons on the website.
                li How do I change my cookie settings?
                li You can disable cookies or customise your cookie settings in your browser settings.
            div  To find out more about cookies, including how to see what cookies have been set, visit www.aboutcookies.org or www.allaboutcookies.org.
            div Find out how to manage cookies on popular browsers:
            ul 
                li Google Chrome
                li Microsoft Edge
                li Mozilla Firefox
                li Microsoft Internet Explorer
                li Opera
                li Apple Safari
            div In order to try and provide all the information you're legally entitled to we have, in part, used wording from the Information Commissioner's Office own website.
            div If anyone requires any further information or believes we should be providing additional details please get in touch and we will try and rectify any issues as soon as possible. Thanks!

            h5 RewardDeals.co.uk
            h7 Share a great deal to earn a great deal!


    Footer
</template>

<style lang='stylus' scoped>
@import "../../stylus/mixins.styl";

.content-wrapper
    flexbox(column, center, center)
    margin 30px 300px

    @media (max-width: 800px) 
        margin 30px 10px
        overflow auto
    padding 20px
    background-color white
    img
        width 300px
        self-align center

    .image
        text-align center

</style>

<script>
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default {
    components: {
        Navbar,
        Footer,
    },

};
</script>
